const ITEMS = [
  "Deep-Tech",
  "Sovereign AI",
  "Robotics & IoT",
  "Smart Cities",
  "Connected Mobility",
  "Agritech",
  "Industry 4.0",
  "Fintech",
  "Intellectual Property",
  "Cross-Border Scaling",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="focus-marquee"
      className="overflow-hidden border-y border-[rgba(212,175,55,0.2)] bg-[#0A1222] py-6"
      aria-label="Focus areas"
    >
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center" data-testid={i < ITEMS.length ? `marquee-item-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-")}` : undefined}>
            <span className="whitespace-nowrap px-8 font-serif text-2xl italic tracking-wide text-[#94A3B8] sm:text-3xl">
              {item}
            </span>
            <span className="text-sm text-[#D4AF37]">◆</span>
          </span>
        ))}
      </div>
    </section>
  );
}
